import React from 'react';
import style from './index.module.scss';

const NmckFuelCalculationInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Расчет НМЦК на ГСМ</h1>
    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Обосновать размер НМЦК при закупке ГСМ, применяя обязательную методику, установленную Приказом ФАС России от
          22.11.2024 № 894/24.
        </div>
      </div>
    </div>
  </>
);

export default NmckFuelCalculationInfo;
